import React from 'react';
import { CoderAvatar, CoderAvatarVariant } from '../coder-avatar/coder-avatar';
import { CoderQueueCount } from '../coder-queue-count/coder-queue-count';
import {
  CoderActionButton,
  CoderActionVariant
} from '../coder-action-button/coder-action-button';
import './coder-list-item.scss';

export interface CoderListItemProps {
  coderName: string;
  queueCount: number;
  avatarVariant: CoderAvatarVariant;
  actionVariant: CoderActionVariant;
  onAction: () => void;
}

export const CoderListItem: React.FC<CoderListItemProps> = ({
  coderName,
  queueCount,
  avatarVariant,
  actionVariant,
  onAction
}) => {
  return (
    <div className="cmx-coder-list-item">
      <CoderAvatar name={coderName} variant={avatarVariant} />
      <div className="cmx-coder-list-item__info">
        <span className="cmx-coder-list-item__name">{coderName}</span>
        <CoderQueueCount count={queueCount} context={avatarVariant} />
      </div>
      <CoderActionButton variant={actionVariant} onClick={onAction} />
    </div>
  );
};

CoderListItem.displayName = 'CoderListItem';
